import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {BackofficePortfolio} from 'src/app/domain/model/backoffice-portfolio/backoffice-portfolio.model';
import {AppEnvironmentService} from 'src/app/infrastructure/environment/app-environment/app-environment.service';
import {Router} from 'src/app/infrastructure/router/router';
import {OnboardingPortfolioService} from 'src/app/infrastructure/service/contracting/shared/portfolio/onboarding-portfolio.service';
import {WebPage} from 'src/app/ui/webapp/page/web.page';

@Component({
  selector: 'app-onboarding-editable-summary-allocation',
  templateUrl: 'onboarding-editable-summary-allocation.page.html'
})
export class OnboardingEditableSummaryAllocationPage extends WebPage {
  public boPortfolio: BackofficePortfolio;

  constructor(
    private portfolioService: OnboardingPortfolioService,
    appEnvironment: AppEnvironmentService,
    router: Router,
    titleService: Title
  ) {
    super(router, appEnvironment, titleService);
  }

  protected onInit() {
    super.onInit();
    this.subscribe(this.portfolioService.currentBoPortfolio$(), (boPortfolio) => this.boPortfolio = boPortfolio);
  }
}
